// action - account reducer
export const LOGIN = 'LOGIN';
export const UPDATE_SHOW_DIALOG_LOCALLY = 'UPDATE_SHOW_DIALOG_LOCALLY';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const VERIFY_CODE = 'VERIFY_CODE';
export const SET_SPINWHEEL_TRADELINE = 'SET_SPINWHEEL_TRADELINE';
export const SET_SMS_VERIFICATION = 'SET_SMS_VERIFICATION';
